// extracted by mini-css-extract-plugin
module.exports = {"sales-report":"sales-report___14f7H"};